module.exports = __webpack_public_path__ + "static/media/analytics.2ed7f3f6.svg";